/**
 * Вход через Instagram в попапе: открыть окно, дождаться кода от
 * `/oauth/callback` (он шлёт его в открывшее окно сообщением).
 *
 * Один путь на двоих: админ подключает наш паблик со всеми правами,
 * партнёр — свой, только с профилем и статистикой (23.10.2026).
 */

import { openLoginPopup } from '../../../shared/lib/loginPopup';

export const INSTAGRAM_REDIRECT_URI = `${window.location.origin}/oauth/callback`;

/** Наш паблик: публикация, комментарии, сообщения, статистика. */
export const STAFF_SCOPES = [
  'instagram_business_basic',
  'instagram_business_manage_messages',
  'instagram_business_manage_comments',
  'instagram_business_content_publish',
  'instagram_business_manage_insights',
];

/** Партнёр: нам нужна только статистика его видео — больше не просим. */
export const PARTNER_SCOPES = ['instagram_business_basic', 'instagram_business_manage_insights'];

export function instagramAuthUrl(scopes: string[]): string {
  return 'https://api.instagram.com/oauth/authorize' +
    '?enable_fb_login=0' +
    '&force_reauth=1' +
    '&client_id=844490794683122' +
    `&redirect_uri=${encodeURIComponent(INSTAGRAM_REDIRECT_URI)}` +
    '&response_type=code' +
    `&scope=${encodeURIComponent(scopes.join(','))}` +
    '&state=instagram';
}

/** Ошибка, которую пользователю показывать не надо: он сам закрыл окно. */
export class InstagramLoginClosed extends Error {
  constructor() { super('Окно входа Instagram закрыто'); }
}

/**
 * Код авторизации из попапа. Окно заблокировано, закрыто или Instagram
 * вернул ошибку — отказ с понятным текстом.
 */
export function instagramLoginCode(scopes: string[]): Promise<string> {
  const popup = openLoginPopup(instagramAuthUrl(scopes), 'instagram-auth');
  if (!popup) {
    return Promise.reject(new Error('Браузер заблокировал всплывающее окно. Разрешите попапы для этого сайта.'));
  }

  return new Promise((resolve, reject) => {
    const done = () => {
      window.removeEventListener('message', handleMessage);
      clearInterval(closedChecker);
    };
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      const type = event.data?.type;
      if (type !== 'instagram_oauth_code' && type !== 'instagram_oauth_error') return;
      done();
      if (type === 'instagram_oauth_error') reject(new Error(event.data.error || 'Ошибка авторизации Instagram'));
      else resolve(event.data.code);
    };
    window.addEventListener('message', handleMessage);
    // Следим за закрытием попапа без завершения авторизации
    const closedChecker = setInterval(() => {
      if (popup.closed) {
        done();
        reject(new InstagramLoginClosed());
      }
    }, 500);
  });
}
